module.exports = __webpack_public_path__ + "Img_RabeaTitanio_512px.png";